import { createContext, useContext } from "react";
import { CrossDomainParams } from "./types";

interface CrossDomainTrackingContextType {
  crossDomainParams: CrossDomainParams;
  isInitialized: boolean;
}

const CrossDomainTrackingContext = createContext<
  CrossDomainTrackingContextType | undefined
>(undefined);

export const useCrossDomainTracking = (): CrossDomainTrackingContextType => {
  const context = useContext(CrossDomainTrackingContext);
  if (context === undefined) {
    throw new Error(
      "useCrossDomainTracking must be used within a CrossDomainTrackingProvider",
    );
  }
  return context;
};

export { CrossDomainTrackingContext };
export type { CrossDomainTrackingContextType };
